import { useSetPlayerStoreData } from '../hooks'
import { playerStoreKeys } from '../playerStoreConstants'
import { usePlayerStore } from '../hooks/usePlayerStore'
import { useCallback } from 'react'

export const useSetPlayerTokens = () => {
  const { setPlayerStoreData } = useSetPlayerStoreData()
  const playerStore = usePlayerStore()

  const refreshCount = playerStore.use.refreshCount()

  const setPlayerTokens = useCallback(
    (data, updateCount = true) => {
      const newTokensData = {
        [playerStoreKeys.accessToken]: data[playerStoreKeys.accessToken],
        [playerStoreKeys.refreshToken]: data[playerStoreKeys.refreshToken]
      }

      if (updateCount) {
        newTokensData[playerStoreKeys.refreshCount] = refreshCount + 1
      }

      setPlayerStoreData(newTokensData, 'setPlayerTokens')
    },
    [refreshCount, setPlayerStoreData]
  )

  return { setPlayerTokens }
}
